import { render, staticRenderFns } from "./ManyEmptyResult.vue?vue&type=template&id=13b5078e"
import script from "./ManyEmptyResult.vue?vue&type=script&lang=ts"
export * from "./ManyEmptyResult.vue?vue&type=script&lang=ts"
import style0 from "./ManyEmptyResult.vue?vue&type=style&index=0&id=13b5078e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports